import { graphql } from "@cappelendamm/crystallize-types/core/gql";
export const GetOrganizationCustomer = graphql(`
  query GetOrganizationCustomerByIdentifier($identifier: String!) {
    customer(identifier: $identifier) {
      __typename
      ... on Customer {
        identifier
        type
        createdAt
        companyName
        email
        phone
        organizationNumber: metaProperty(key: "organizationNumber")
        organizationType: metaProperty(key: "organizationType")
        addresses {
          type
          firstName
          lastName
          street
          postalCode
          city
          country
          phone
          email
          meta {
            key
            value
          }
        }
        meta {
          key
          value
        }
        parents {
          identifier
        }
      }
      ... on BasicError {
        errorName
        message
      }
    }
  }
`);
